import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashbaord-footer',
  templateUrl: './dashbaord-footer.component.html',
  styleUrls: ['./dashbaord-footer.component.scss']
})
export class DashbaordFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
